<div
    class="w-full bg-white p-7 z-50 relative rounded-[10px] border-[1px] border-[#E7E7E7] max-h-[70vh] custom-scroll overflow-y-auto">
    <button
        *ngIf="recentSearch.length > 0"
        type="button"
        class="absolute top-[30px] right-[30px]"
        (click)="onFilterClear()">
        <mat-icon svgIcon="trash-fill" class="text-[#FF9696] hover:text-red-400"></mat-icon>
    </button>

    <div *ngIf="recentSearch.length > 0" class="mb-[1.875rem]">
        <h2 class="header">{{ 'text.recentSearch' | translate }}</h2>

        <div class="mt-1">
            @for (item of recentSearch; track item) {
                <div class="inline-block">
                    <div class="recent-search-pill mr-2 space-x-3 mt-3">
                        <button type="button" class="flex items-center" (click)="onSuggestedKeyword(item.text)">
                            <p>{{ item.text }}</p>
                        </button>

                        <button type="button" class="flex items-center" (click)="onClickDelete(item.id)">
                            <mat-icon svgIcon="close" class="!w-3 !mt-0 text-[#859296]"></mat-icon>
                        </button>
                    </div>
                </div>
            }
        </div>
    </div>

    <div>
        <div class="flex items-center space-x-1">
            <h2 class="header">{{ 'text.hotTopic' | translate }}</h2>
            <div class="bg-icon-trending-up icon-[24px]"></div>
        </div>

        @for (item of hotTopic; track item; let last = $last) {
            <div class="topic-items" [ngClass]="{ 'border-b-[1px] border-[#E7E7E7]': !last }">
                <a [href]="item.linkToPage" (click)="onClickHotTopic()">
                    <p class="text-[#5F5B5B] font-medium text-base ellipsis-line-2 hover:text-primary">
                        {{ item.title }}
                    </p>
                </a>
            </div>
        }

        @if (isLoading) {
            <div class="animate-pulse space-y-4 rounded-2xl mt-4">
                @for (item of [0, 1, 2, 3, 4, 5]; track item) {
                    <div class="loader h-9 w-full rounded-md"></div>
                }
            </div>
        }
    </div>
</div>
